/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Mixing_Program_VoInputs */



/**
* | output |
* | --- |
* | "Mixing program and VO audio..." |
*
* @param {Audio_Description_Export_Status_Mixing_Program_VoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_mixing_program_vo = /** @type {((inputs?: Audio_Description_Export_Status_Mixing_Program_VoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Mixing_Program_VoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mixage de l'audio du programme et de la VO...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mischprogramm und VO-Audio...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Programma di mixaggio e audio VO...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Программное микширование и озвучивание...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Programa de mezcla y audio VO...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("混合节目和配音音频……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プログラムと VO オーディオをミキシングしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिक्सिंग प्रोग्राम और वॉयस ओवर ऑडियो...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Programa de mixagem e áudio de locução...")
	return /** @type {LocalizedString} */ ("Mixing program and VO audio...")
});